import '../sass/style.scss';
import slider from './modules/slider';
import smoothScroll from './modules/smoothScroll';
import animation from './modules/animation';
import { setItems } from './modules/animation';
import mouseEffect from './modules/mouseEffect';
import setIframeHeight from './modules/setIframeHeight';

document.addEventListener('DOMContentLoaded', () => {
  // cloneHeader();
  // setVariables();
  setItems();
  smoothScroll();
  slider();
  // animation();
  // accordion();
  // modal();

  // setIframeHeight();
});

const frame = document.querySelector('#form-frame');

window.addEventListener('load', () => {
  animation();
  mouseEffect();
  setIframeHeight();
});

frame.onload = () => {
  console.log('load');
  const body = frame.querySelector('body');
  console.log(body);
};
